module.exports = __webpack_public_path__ + "media/KikiJC.9ff5c7a8.mp3";